import { getFunctions, httpsCallable } from "firebase/functions";

class UnsubscribeService {
    private static instance: UnsubscribeService | null = null;

    public static getInstance(): UnsubscribeService {
        if (this.instance === null) {
            this.instance = new UnsubscribeService();
        }
        return this.instance;
    }

    public async unsubscribeUserAsync(email: string): Promise<boolean> {

        var functions = getFunctions();
        const unsubscribeUser = httpsCallable(functions, 'unsubscribeUserFunction');
        return await unsubscribeUser(
            {
                "userEmail": email,
            })
            .then((result: any) => {
                return result.data['success'];
            }).catch((error) => {
                return false;
            });
    }
}

const useUnsubscribeService = () => {
    return UnsubscribeService.getInstance();
}

export default useUnsubscribeService;